/* eslint-disable */
const FolderClosed = (props) => {
  return `<svg id='folder-closed' width=${props.width || '161px'} height=${
    props.height || '130px'
  } viewBox="0 0 161 130" xmlns="http://www.w3.org/2000/svg" style="min-width:${
    props.width
  }"><g fill="none" fill-rule="evenodd"><path d="M15 0h41l18 17h72c8.284 0 15 6.716 15 15v83c0 8.284-6.716 15-15 15H15c-8.284 0-15-6.716-15-15V15C0 6.716 6.716 0 15 0z" fill="#FFAF00"/><path d="M15 17h131c8.284 0 15 6.716 15 15v83c0 8.284-6.716 15-15 15H15c-8.284 0-15-6.716-15-15V32c0-8.284 6.716-15 15-15z" fill="#FFD233"/></g></svg>`;
};

export default FolderClosed;
/* eslint-enable */
